'use client';

import React from 'react';
import Image from 'next/image';
import styles from './styles/Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <div className={styles.footerSection}>
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/about">About</a></li>
            <li><a href="/catalog">Courses</a></li>
            <li><a href="/footer/refund">Refund</a></li>
            <li><a href="/login">Login</a></li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h3>Support</h3>
          <ul>
            <li><a href="/footer/safety">Safety</a></li>
            <li><a href="/footer/privacy-policy">Privacy</a></li>
            <li><a href="/footer/ca-privacy">CA Privacy</a></li>
            <li><a href="/footer/learnerprivacy">Learner Privacy</a></li>
            <li><a href="/footer/terms">Terms</a></li>
            <li><a href="/footer/esa">ESA</a></li>
          </ul>
        </div>

        <div className={styles.footerSection}>
          <h3>Teach</h3>
          <ul>
            <li><a href="/footer/independent-teachers">Teach with us</a></li>
            <li><a href="/footer/educator_handbook">Educator Handbook</a></li>
          </ul>
        </div>

      </div>

      <div className={styles.footerBottom}>
        <div className={styles.socialLinks}>
          <a
            href="https://www.facebook.com/penguinlearn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="PenguinLearn on Facebook"
          >
            <Image
              src="/images/fb-icon.webp"
              alt="Facebook"
              width={24}
              height={24}
              loading="lazy"        
              sizes="24px"
            />
          </a>
          <a
            href="https://www.instagram.com/penguinlearn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="PenguinLearn on Instagram"
          >
            <Image
              src="/images/ig-icon.webp"
              alt="Instagram"
              width={24}
              height={24}
              loading="lazy"        
              sizes="24px"
            />
          </a>
        </div>
        <p className={styles.copyright}>
          © PenguinLearn {new Date().getFullYear()}
        </p>
      </div>
    </footer>
  );
}
